<div class="wrapper">
    <div class="block-center mt-4 wd-responsive">
      <!-- START card-->
      <div class="card card-flat">
        <div class="card-header text-center bg-primary">
          <img
            class="solimarket"
            src="/assets/img/solimarket-portal.png"
            alt="image"
          />
        </div>
        
        <div class="card-body" style="padding-top: 2em !important">
            <div *ngIf="!isUnsubscribe">
                <div class="confirm-text"><p><strong>Please confirm that you would like to unsubscribe. You will no longer receive any emails from SoliMarket. </strong></p></div>
                <div class="row btn-unsubcribe">
                    <button
                    class="btn btn-block btn-primary mt-2"
                    (click)="unsubscribe()"
                    >
                    Unsubscribe
                    </button>
                </div>
            </div>
            <div *ngIf="isUnsubscribe">
                <div class="confirm-text"><p><strong>{{message}}</strong></p></div>
            </div>
            
        </div>
    </div>
    </div>
</div>


